/*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/
import React, { useEffect, useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Spin from "../Spinner/Spin";
const Incomechart = ({incomeData,loading}) => {
  let navigate = useNavigate();
  const [labels,setlabel]=useState([])
  const [type,settype]=useState('subscription')
  const [periods,setperiod]=useState('week')
  const [title,settitle]=useState('')
  const[val,setval]=useState()
  const [listperiod,setlist]=useState([])
  const [showIncome, setShowIncome] = useState(true);
  const[flag,setflag]=useState(false)
  const calc= (res) =>{
    var sum = 0;
    var sum_i = 0;
    for(var i=0; i<res.length;i++){
      var add = sum + res[i].count
      sum = add;
    }
  }
  const toggleIncome = () => {
    setShowIncome(!showIncome);
  };
  return (
    <>
    {/* <div className="graphsone">
        <div>
    <div className='head'>
        <div className='col-md-6'>
          <p><i className="fa fa-cube" ></i>  Income </p>
          <p style={{'padding':'0 5px 0 32px','fontSize':'14px'}}>showing result for <b>{title}</b></p>
        </div>
      </div>
      <AreaChart
        width={1000}
        height={440}
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Area type="monotone" dataKey="uv" stroke="#e24585" fill="#e24585" />
      </AreaChart>
      </div>
      <div className="selectorGraphs">
          <select id="voovi" name="voovi" placeholder="select one option">
            <option value="">Daily</option>
            <option value="">Monthly</option>
            <option value="">Quaterly</option>
            <option value="">Yearly</option>
          </select>
        </div>
      </div> */}
          <div className='graphsme'>
        <div className='graphsme01'>
          <p>
            <h5>Income Data</h5>
            <span onClick={toggleIncome}>{showIncome ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon/>}</span>
          </p>
          {showIncome && incomeData && !loading  ?
            <div className='graphsme02'>
              <p>
                <span>Today's Income Total: &nbsp;</span>
                <span>
                  <b>
                    {incomeData.todayIncome && incomeData.todayIncome[0]
                      ? `₹ ${incomeData.todayIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Yesterday's Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.yesterdayIncome && incomeData.yesterdayIncome[0]
                      ? `₹ ${incomeData.yesterdayIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Weekly Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.weeklyIncome && incomeData.weeklyIncome[0]
                      ? `₹ ${incomeData.weeklyIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Biweekly Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.biweeklyIncome && incomeData.biweeklyIncome[0]
                      ? `₹ ${incomeData.biweeklyIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Monthly Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.monthlyIncome && incomeData.monthlyIncome[0]
                      ? `₹ ${incomeData.monthlyIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Quarterly Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.quarterlyIncome && incomeData.quarterlyIncome[0]
                      ? `₹ ${incomeData.quarterlyIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Annual Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.annualIncome && incomeData.annualIncome[0]
                      ? `₹ ${incomeData.annualIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Life Income Total:&nbsp;</span>
                <span>
                  <b>
                    {incomeData.lifeIncome && incomeData.lifeIncome[0]
                      ? `₹ ${incomeData.lifeIncome[0].totalAmount}`
                      : "NA"}
                  </b>
                </span>
              </p>
            </div>:
            <div className="spindefault">
            <Spin/>
            </div>
          }
        </div>
      </div>
    </>
  )
}
export default Incomechart;



// import React,{useEffect,useState} from 'react';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Line } from 'react-chartjs-2';
// import AsyncSelect from 'react-select/async';
// import sampler from '../../Objects/axiosjson';
// import { Opt , Listperiod} from '../../Objects/Country';
// const Incomechart = () => {
// const [labels,setlabel]=useState([])
// const [type,settype]=useState('income')
// const [periods,setperiod]=useState('week')
// const [title,settitle]=useState('')
// const[val,setval]=useState()
// const [listperiod,setlist]=useState([])

// const opt=async()=>{
//   return Opt();
// }
// useEffect(()=>{
//   const ff = Listperiod();
//   setlist(ff)
// },[])
// useEffect(()=>{
//   const params= {
//     "type":type,
//     "periods":periods
//     }

// sampler.post('/getChartData',params)
// .then(res =>{
//   if(res.data.error === false){
//     let result = [{totalAmount:'',count:'',date:''}];
//     result = res.data.data;
//     calc(result)
//     setlabel(result.map(x=> { return x.date }))
//     setval(result.map(x=>{return x.count} ))
//     const upper = periods.toUpperCase();
//     settitle(upper)
//   }

// })
// return null
// },[periods])
// const handle=(x)=>{
//   setperiod(x)

// }
// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
//   );
//     const options = {
//         responsive: true,
//         plugins: {
//           legend: {
//             position: 'bottom',
//           }

//         },
//       };

//       const data = {
//         labels ,
//         datasets: [
//           {
//             label: 'Total Income',
//             data: val,
//             borderColor: '#e24585',
//             backgroundColor: '#e24585',
//           },

//         ],
//       };
//       const[selectvalue,setselectvalue]=useState({label:'Graph'});
//       const[flag,setflag]=useState(false)

//       const handleopt=(e)=>{
//         setselectvalue(e)
//         if(e.label === 'Data'){
//           setflag(!flag)
//         }else{
//           setflag(false)
//         }
//       }

//       const [subs,setsubs]=useState('')
//       const [amount,setamount]=useState('')
//       const calc= (res) =>{
//         var sum = 0;
//         var sum_i = 0;
//         for(var i=0; i<res.length;i++){
//           var add = sum + res[i].count
//           sum = add;
//         }
//         setsubs(sum)
//         for (var j=0;j<res.length;j++){
//           var add1 = sum_i + res[j].totalAmount
//           sum_i = add1
//         }
//         setamount(sum_i)
//       }
//   return (
//     <>
//           <div className='container-fluid p-0 m-0 graph'>
//             <div className='head bg-light'>
//               <div className='row'>
//               <div className='col-md-6'>
//                 <p><i className="fa fa-money-check" ></i> Income </p>
//                 <p style={{'padding':'0 5px 0 32px','fontSize':'14px'}}>showing result for <b>{title}</b></p>
//                 </div>

//               <div className='col-md-6'>
//                 {!flag ?
//                 <div>
//                 <span>Y-Axis - number of Income (INR)</span><br/>
//                 <span>X-Axis - Time / Date / Month</span>
//                 </div>
//                 :''}

//               </div>
//               </div>
//             </div>

//             <div className='row'>
//             <div className='col-md-9 bg-light rounded'>
//            {!flag ?
//            <Line
//             height={240}
//             data={data} options={options}/>
//             :
//             <div className='data'>
//               <p>Total Income: {amount} &#x20B9; </p>

//             </div>
//             }
//            </div>
//            <div className='col-md-3 bg-light rounded p-1'>

//            <AsyncSelect
//            className='drop'
//                         cacheOptions
//                         defaultOptions
//                         value={selectvalue}
//                         defaultValue={selectvalue}
//                         getOptionLabel={e => e.label}
//                         getOptionValue={e => e.label}
//                         loadOptions={opt}
//                         onChange={handleopt}
//                     />
//             <div className='Paper mt-2'>
//               {listperiod.map((x,index)=>{
//                 return(
//                   <li key={index}>{x.icon}<span onClick={()=> handle(x.value)}>{x.Name}</span></li>
//                 )
//               })}
//             </div>
//            </div>

//             </div>

//           </div>

//     </>

//   )
// }
